import { render, staticRenderFns } from "./MyLegalShops.vue?vue&type=template&id=060ba8b8&"
import script from "./MyLegalShops.vue?vue&type=script&lang=js&"
export * from "./MyLegalShops.vue?vue&type=script&lang=js&"
import style0 from "./MyLegalShops.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports